import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as feed from './feed'
import * as header from './header'

/**
 * Page in Summit used to view and manage your check-ins
 */
@ngCore.Component({
  imports: [ds.layout.page.Component, header.Component, feed.Component],
  selector: 'atn-summit-check-ins-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)
}
